import { render } from "./QueueCleint.vue?vue&type=template&id=43d61f86&scoped=true"
import script from "./QueueCleint.vue?vue&type=script&lang=js"
export * from "./QueueCleint.vue?vue&type=script&lang=js"

import "./QueueCleint.vue?vue&type=style&index=0&id=43d61f86&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d61f86"]])

export default __exports__